import { useEffect } from 'react';
import { useUser } from 'hooks/useUser';
import { useButlletins } from 'hooks/corporatiu/useButlletins';
import Slider from 'components/corporatiu/Slider';
import DestacatButlleti from 'components/corporatiu/Butlletins/DestacatButlleti';
import styles from './sliderbutlletins.module.scss';

const SliderButlletins = (props) => {
    const { items } = props;
    const { isAuthenticated, accessToken } = useUser();
    const { getSubscripcionsButlletins } = useButlletins();

    useEffect(() => {
        if (isAuthenticated && accessToken) {
            getSubscripcionsButlletins();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthenticated, accessToken]);
    return (
        <>
            {items && (
                <div className={styles.sliderButlletins}>
                    <Slider format='butlletins' fletxes='mig'>
                        {items.map((item, index) => {
                            return (
                                <div className={styles.butlleti} key={`slider-butlleti-${index}`}>
                                    <DestacatButlleti item={item} estil='inSlider' />
                                </div>
                            );
                        })}
                    </Slider>
                </div>
            )}
        </>
    );
};

export default SliderButlletins;
